// import PlansCheckout from "Components/PlansCheckout"
// import { Footer } from "Layouts/Footer/Footer"
import { useEffect } from "react"
import { FaSpinner } from "react-icons/fa"
import { useNavigate } from "react-router-dom"

export const Offerta = () => {
   const navigate = useNavigate()

   useEffect(() => {
      navigate("/")
   }, [])

   return (
      <div className='sm:container py-20 w-[96%] mx-auto flex flex-col items-center justify-center gap-14 lg:min-h-[85vh]'>
         <FaSpinner className='animate-spin' />
         {/* <PlansCheckout />
         <Footer /> */}
      </div>
   )
}
